<template src="./template.html"></template>
<script>
import { mapState } from 'vuex'

import bookingService from 'api/booking'

export default {
  name: 'express-checkout-complete',
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapState({
      date: (state) => state.date.current,
      venue: (state) => state.venue.current,
      booking: (state) => state.checkout.booking,
    }),
  },
  methods: {},
  mounted() {
    if (!this.booking) {
      this.loading = true

      bookingService
        .getById(this.$route.query.bookingId)
        .then((result) => {
          this.$store.dispatch('setCheckoutBooking', result)

          this.$store.dispatch('setCurrentVenue', result.venue)

          this.loading = false
        })
        .then(() => {
          return null
        })
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/ExpressCheckoutComplete/index.vue